module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2-1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("Contents")])])])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "2",
      "src": "images/line.jpg",
      "width": "130"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top3"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction"
    }
  }, [_c('b', [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpa1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Part01"
    }
  }, [_c('b', [_vm._v("Part I: The Law")])])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter01"
    }
  }, [_vm._v("The Law and the Constitution")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lawyers, Judges, and the Practice of Law")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Supreme Court")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women and the Law")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpa2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part II: Civil Liberties: Free to Be You and Me")])])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American Rights and Values")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equal Justice under the Law")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The History of the Women’s Rights Movement")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rights of Women")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reproductive Rights")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpa3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III: A Life of Her Own")])])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories of a Long Life")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friends, Family, and Other Influences")])]), _vm._v(" "), _c('div', {
    staticClass: "topa"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpa4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Milestones")])])])])])])])])])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0